__turbopack_context__.v({
  "body": "ProgramEndCard-module__ROgEjW__body",
  "card": "ProgramEndCard-module__ROgEjW__card",
  "content": "ProgramEndCard-module__ROgEjW__content",
  "copy": "ProgramEndCard-module__ROgEjW__copy",
  "cta": "ProgramEndCard-module__ROgEjW__cta",
  "ctaIcon": "ProgramEndCard-module__ROgEjW__ctaIcon",
  "ctas": "ProgramEndCard-module__ROgEjW__ctas",
  "dots": "ProgramEndCard-module__ROgEjW__dots",
  "help": "ProgramEndCard-module__ROgEjW__help",
  "helpLink": "ProgramEndCard-module__ROgEjW__helpLink",
  "section": "ProgramEndCard-module__ROgEjW__section",
  "sectionAlt": "ProgramEndCard-module__ROgEjW__sectionAlt",
  "title": "ProgramEndCard-module__ROgEjW__title",
});
